<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      >
    </selectTool>
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "车牌号",
          key: "carNo",
          sort: 10,
        },
        {
          title: "设备号",
          key: "deviceNo",
          sort: 10,
        },
        {
          title: "所属单位",
          key: "groupName",
          sort: 10,
        },
        {
          title: "行驶时长/分钟",
          key: "plyDuration2",
          sort: 10,
        },
        {
          title: "完整时长/分钟",
          key: "cpteDuration2",
          sort: 10,
        },
        {
          title: "有效里程/公里",
          key: "validMileage",
          sort: 10,
        },
        {
          title: "完整里程/公里",
          key: "cpteMileage",
          sort: 10,
        },
        {
          title: "完整比率/%",
          key: "cpteRate",
          sort: 10,
        },
        {
          title: "轨迹日期",
          key: "trackDate2",
          sort: 10,
        },
        {
          title: "原因描述",
          key: "cause",
          sort: 10,
        },
      ],
      tableData: [],
      item: {
        name: "",
        icon: "car",
        remark: "",
        category: "其他类",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },
      ],
      total: 0,
     
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/count/countCpteRate",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].trackDate2 = this.utils.time(data[i].trackDate, "yymmdd");
          data[i].plyDuration2 = Math.ceil(data[i].plyDuration / 60);
          data[i].cpteDuration2 = Math.ceil(data[i].cpteDuration / 60);
        }
        this.tableData = data;
        console.log(data);
      });
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },

    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/gjwzl.vue